import React from 'react'
import { NavLink } from 'react-router-dom';
import { FaFacebook } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';
import { BiLogoGmail } from 'react-icons/bi';
import { BiSolidPhoneCall } from 'react-icons/bi';
import { HiOutlineChevronDoubleRight } from 'react-icons/hi';
const Footer = () => {
    return (
        <>
            <section className="footer d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <h3>Muhammad Rizwan</h3>
                            <h6>About Company</h6>
                            <p style={{ textAlign: "justify" }}>Our company was founded in 2020 by a group of friends who shared a passion for software engineering. At the time, they were all working for different companies, but they shared a common goal: to create a company that would provide businesses with the tools they need to succeed online. They saw the potential of the Internet and wanted to help businesses take advantage of it.</p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <h3>USE FULL LINKS</h3>
                            <div className="use-full-link">
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Portfolio" className="text-white">My Portfolio</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Web_Application" className="text-white">Web Application</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Web_Development" className="text-white">Web Development</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/IOS_Development" className="text-white">IOS Development</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Graphic_Design" className="text-white">Graphic Designing</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Android_Development" className="text-white">Android Development</NavLink> <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="/Software_Development" className="text-white">Software Development</NavLink> <br />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <h3>Social Icons</h3>
                            <div className="icon">
                                <HiOutlineChevronDoubleRight /> <NavLink to="tel:923245097351"><BiSolidPhoneCall className="text-white" /></NavLink> Phone<br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="mailto:ranarizwan7351@gmail.com"><BiLogoGmail className="text-white" /></NavLink> Mail<br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="https://www.facebook.com/profile.php?id=100090649845449"><FaFacebook className="text-white" /></NavLink> Facebook <br />
                                <HiOutlineChevronDoubleRight /> <NavLink to="https://www.linkedin.com/in/muhammad-rizwan-82031a235/"><FaLinkedinIn className="text-white" /></NavLink> Linkedin <br /><br />
                            </div>
                        </div>
                    </div><hr />
                    <div className="d-flex flex-wrap  justify-content-between">
                        <p>© Copyright M-R . All Rights Reserved </p>
                        <p>Designed by <NavLink className="text-decoration-none text-white" to="mailto:ranarizwan7351@gmail.com"><strong> Muhammad Rizwan </strong></NavLink></p>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Footer